import { render } from "./MessageAddCartConfirmPage.vue?vue&type=template&id=2e514848"
import script from "./MessageAddCartConfirmPage.vue?vue&type=script&lang=js"
export * from "./MessageAddCartConfirmPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__